<template>
  <div id="the-good">
    <b-container class="the-good-container">
      <div class="gitg-logo-container" v-if="global.screenWidth > 992">
        <img
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Logo.png')
          "
        />
      </div>
      <div class="good-content">
        <div class="header-align">
          <Header title="The Good" :alignBarStart="global.screenWidth > 992" />
        </div>
        <img
          v-if="global.screenWidth <= 992"
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Logo.png')
          "
        />

        <p>
          Founded in 1986 by Donald J. DePorter, Chicago Gateway Green is a
          nonprofit, public-private partnership dedicated to the greening and
          beautification of Chicago’s expressways, gateways and neighborhoods
          through landscape enhancement, litter removal and the installation of
          public art.
          <br />
          <br />
          Gateway Green's Expressway Program is unique from traditional
          Adopt-A-Highway programs. With the support of the City of Chicago,
          Illinois Department of Transportation, and its Corporate Sponsors,
          Chicago Gateway Green develops and maintains sweeping sustainable
          landscapes along Chicago's expressways. Gateway Green works closely
          with professional landscape crews to provide plant care, weed control,
          mowing and litter removal from April through October.
        </p>
        <ImageGallery
          style="margin-top: 40px; margin-bottom: 40px"
          :data="[
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-09.jpg'),
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-02.jpg'),
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-03.jpg'),
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-06.jpg'),
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-07.jpg'),
            require('@/assets/images/galleries/pennypinch/thegood/The-Good-Gateway-Green-08.jpg'),
          ]"
          :idString="'thegood'"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import { mapState } from "vuex";
export default {
  name: "TheGood",
  components: {
    ImageGallery,
    Header,
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-good {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-good-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    @media (max-width: 1050px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .gitg-logo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    height: 100%;
    @media (max-width: 1050px) {
      align-items: center;
    }
  }
  .header-align {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;
    height: 100px;
    width: auto;
    @media (max-width: 1050px) {
      justify-content: center;
      margin-bottom: 0;
    }
  }
  .gitg-logo {
    height: 240px;
    width: auto;
    @media (max-width: 1050px) {
      margin-bottom: 37px;
    }
  }
  .good-content {
    width: 670px;
    max-width: 75%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (max-width: 1050px) {
      align-items: center;
      width: 100%;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: 1050px) {
      text-align: center;
    }
  }

  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
